/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentManagementControllerCreateCompleteAssessmentRequestAssessment } from './assessmentManagementControllerCreateCompleteAssessmentRequestAssessment';
import { AssessmentManagementControllerUpdateCompleteAssessmentRequestConfigsInner } from './assessmentManagementControllerUpdateCompleteAssessmentRequestConfigsInner';
import { AssessmentManagementControllerUpdateCompleteAssessmentRequestSectionsInner } from './assessmentManagementControllerUpdateCompleteAssessmentRequestSectionsInner';
import { AssessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInner } from './assessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInner';


export interface AssessmentManagementControllerUpdateCompleteAssessmentRequest { 
    assessment: AssessmentManagementControllerCreateCompleteAssessmentRequestAssessment;
    sections?: Array<AssessmentManagementControllerUpdateCompleteAssessmentRequestSectionsInner>;
    questions?: Array<AssessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInner>;
    configs?: Array<AssessmentManagementControllerUpdateCompleteAssessmentRequestConfigsInner>;
    modifiedBy?: number;
}

